import { FaBell, FaWhatsapp } from "react-icons/fa";

const FloatingWhatsAppVB = () => {
  return (
    <a
      href="https://wa.me/551148633465"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-[7.5rem] right-6 z-50"
      aria-label="WhatsApp"
    >
      <div className="relative">
        <div className="bg-green-500 rounded-full w-14 h-14 flex items-center justify-center shadow-lg hover:scale-105 transition-transform">
          <FaWhatsapp className="text-white text-2xl" />
        </div>

        <span className="absolute -top-1 -right-1 bg-red-600 rounded-full p-1 flex items-center justify-center">
          <FaBell className="text-white text-[10px] animate-ring" />
        </span>
      </div>
    </a>
  );
};

export default FloatingWhatsAppVB;
